export default __webpack_public_path__ + "static/media/timer.6fd8a866.svg";